(()=>{
    const saveToHomeScreen = document.querySelector(".js-save-to-home-screen");
    const background = saveToHomeScreen.querySelector(".js-background");
    const popup = saveToHomeScreen.querySelector(".js-popup");
    const popupCta = popup.querySelector(".js-cta");
    const popupClose = popup.querySelector(".js-close");
    const popupGuide = saveToHomeScreen.querySelector(".js-guide");
    const popupGuideClose = popupGuide.querySelector(".js-close");
    const TWO_MONTHS_IN_MILLIS = 5184000000;
    const popupData = "save-to-home-screen-bingo";
    // Initialize deferredPrompt for use later to show browser install prompt.
    let deferredPrompt;
    const debug = (id, text, isJson)=>{
        document.getElementById(id).innerHTML = isJson ? JSON.stringify(text, undefined, 2) : text;
    };
    const getOS = ()=>{
        const userAgent = navigator.userAgent;
        if (/android/i.test(userAgent)) return "android";
        if (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return "ipad";
        if (/iPad|iPhone|iPod/.test(userAgent)) return "ios";
        return "unknown";
    };
    const browserIsSafari = ()=>{
        const userAgent = window.navigator.userAgent;
        return /safari/i.test(userAgent) && !/chrome/i.test(userAgent);
    };
    const isInStandaloneMode = ()=>window.matchMedia("(display-mode: standalone)").matches;
    const isLoggedIn = ()=>true;
    /**
   * @namespace popupLogic
   */ const popupLogic = {
        /**
     * Determines if the popup should be shown to the user based on previous interactions and time elapsed.
     * @function
     * @returns {boolean} - Returns `true` if the popup should be shown, `false` otherwise.
     */ shouldShow: function() {
            const data = JSON.parse(localStorage.getItem(popupData)) || {};
            if (data.addedToHome) return false;
            if (!data.hasSeenPopup) return true;
            if (data.closedCount >= 2) {
                if (data.lastClosed) {
                    if (Date.now() - data.lastClosed < TWO_MONTHS_IN_MILLIS) return false;
                    else return true;
                }
            } else if (typeof data.visitCount === "undefined" || data.visitCount >= 5) return true;
            return false;
        },
        /**
     * Registers the user's visit and updates visit count in local storage.
     * @function
     */ registerVisit: function() {
            const data = JSON.parse(localStorage.getItem(popupData)) || {};
            data.hasSeenPopup = true;
            data.visitCount = (data.visitCount || 0) + 1;
            if (data.visitCount >= 6) data.visitCount = 0;
            localStorage.setItem(popupData, JSON.stringify(data));
        },
        /**
     * Registers the action of user closing the popup and updates local storage accordingly.
     * @function
     */ registerClose: function() {
            const data = JSON.parse(localStorage.getItem(popupData)) || {};
            data.hasSeenPopup = true;
            data.visitCount = 1;
            data.closedCount = (data.closedCount || 0) + 1;
            if (data.closedCount >= 2) data.lastClosed = Date.now();
            localStorage.setItem(popupData, JSON.stringify(data));
        },
        /**
     * Registers the action of user clicking "Add to Home Screen" and ensures the popup will not be shown again.
     * @function
     */ registerAddToHome: function() {
            const data = JSON.parse(localStorage.getItem(popupData)) || {};
            data.addedToHome = true;
            localStorage.setItem(popupData, JSON.stringify(data));
        }
    };
    const hidePopup = ()=>popup.classList.add("save-to-home-screen__popup--hidden");
    const hideBackground = ()=>background.classList.add("save-to-home-screen__bg--hidden");
    const showBackground = ()=>background.classList.remove("save-to-home-screen__bg--hidden");
    const hidePopupGuide = ()=>{
        popupGuide.classList.add("save-to-home-screen__guide--hidden");
        hideBackground();
        hideSaveToHomeScreen();
    };
    const showSaveToHomeScreen = ()=>saveToHomeScreen.classList.remove("save-to-home-screen--hidden");
    const hideSaveToHomeScreen = ()=>saveToHomeScreen.classList.add("save-to-home-screen--hidden");
    const handlePopupClose = ()=>{
        hidePopup();
        popupLogic.registerClose();
    };
    const handlePopupCTA = ()=>{
        hidePopup();
        popupLogic.registerAddToHome();
        const os = getOS();
        if (os === "ios" || os === "ipad") {
            showPopupGuide();
            showBackground();
        }
        if (os === "android") {
            addToAndroidHomeScreen();
            hideSaveToHomeScreen();
        }
    };
    const showPopup = ()=>{
        showSaveToHomeScreen();
        popupClose.addEventListener("click", handlePopupClose);
        popupCta.addEventListener("click", handlePopupCTA);
        popup.classList.remove("save-to-home-screen__popup--hidden");
    };
    const showPopupGuide = ()=>{
        popupGuideClose.addEventListener("click", hidePopupGuide);
        background.addEventListener("click", hidePopupGuide);
        popupGuide.classList.remove("save-to-home-screen__popup--hidden");
        popupLogic.registerAddToHome();
    };
    const addToAndroidHomeScreen = ()=>{
        window.addEventListener("appinstalled", ()=>{
            debug("appinstalled", "true");
            popupLogic.registerAddToHome();
        });
        // Show the install prompt
        deferredPrompt.prompt();
        // We've used the prompt, and can't use it again, throw it away
        deferredPrompt = null;
    };
    const addLinkToManifest = ()=>{
        const link = document.createElement("link");
        link.rel = "manifest";
        link.href = "manifest.webmanifest";
        document.head.appendChild(link);
    };
    const addLinkToIcons = ()=>{
        const link1 = document.createElement("link");
        const link2 = document.createElement("link");
        const link3 = document.createElement("link");
        const link4 = document.createElement("link");
        link1.rel = "apple-touch-icon";
        link2.rel = "apple-touch-icon";
        link3.rel = "apple-touch-icon";
        link4.rel = "apple-touch-icon";
        link1.href = "./apple-touch-icon-512.png";
        link2.href = "./apple-touch-icon-167.png";
        link3.href = "./apple-touch-icon-152.png";
        link4.href = "./apple-touch-icon-120.png";
        document.head.appendChild(link1);
        document.head.appendChild(link2);
        document.head.appendChild(link3);
        document.head.appendChild(link4);
    };
    const initializePopupLogic = ()=>{
        if (popupLogic.shouldShow()) showPopup();
        else popupLogic.registerVisit();
    };
    const initializeAndroidInstallPrompt = ()=>{
        window.addEventListener("beforeinstallprompt", (ev)=>{
            debug("beforeinstallprompt", ev, true);
            // Prevent the mini-infobar from appearing on mobile
            ev.preventDefault();
            if (!ev.isTrusted) return;
            // Stash the event so it can be triggered later.
            deferredPrompt = ev;
            initializePopupLogic();
        });
    };
    const initialize = ()=>{
        if (!saveToHomeScreen || isInStandaloneMode() || !isLoggedIn()) return;
        addLinkToIcons();
        addLinkToManifest();
        debug("label", "Added link to &lt;head&gt;");
        const os = getOS();
        switch(os){
            case "ios":
            case "ipad":
                if (browserIsSafari()) initializePopupLogic();
                break;
            case "android":
                initializeAndroidInstallPrompt();
                break;
        }
    };
    window.addEventListener("appinstalled", ()=>{
        debug("appinstalled", "True");
    });
    initialize();
    debug("os", getOS());
    debug("browser", browserIsSafari());
    debug("isPWA", isInStandaloneMode());
})();

//# sourceMappingURL=index.b9ef2f11.js.map
